/**
 * Route for `braze-event-sync-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BrazeEventSyncIntegrationPage } from "../features/braze-event-sync-integration/BrazeEventSyncIntegrationPage";

export const brazeEventSyncIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/braze-event-sync-integration",
	component: BrazeEventSyncIntegrationPage,
});

export default brazeEventSyncIntegrationRoute;
